import { FC, useEffect, useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { AuthContext } from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomTopPayorDetail from "src/components/manufacturer/customComponentDoctorsEnrollemnts";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";
import CaseVolumeColumnChart from "src/components/manufacturer/caseVolumeColumnChart";
import { StatisticsApiResponse } from "../manufacturer/types";
import { areManFiltersUpdated, getDefaultManFilters } from "src/helpers/manufacturer";


const PracticeStats: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();

  const [queryParams, changeQueryParams] = useState(getDefaultManFilters(searchParams, userData, ""));

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        role: searchParams.get("role") || (userData ? userData.ref_type : ""),
        type: "",
        // soc_value: "",
        // drug_id: "",
        user_id: searchParams.get("id") || (userData ? userData.id.toString() : "") || "",
        // insurance_name:'',

      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = (period: string) => {
    const updatedQueries = {
      ...queryParams,
      period,
    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader />
      {statisticsData && (
        <CaseFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      )}
      {statisticsData && (
        <CaseVolumeColumnChart StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={false} />
      )}
      {statisticsData && (
        <CustomTopPayorDetail StatisticsObjectType={statisticsData.data} />
      )}
      <div className="row">
        <div className="col-12">
          <div className="card mt-3">
            <div className="card-header">
              <h5 className="m-0 text-center text-primary">Transfers
              </h5>
            </div>
            <div className="card-body">
              <h6 className="text-center">
                18.143% (14.460%)
              </h6>
            </div>
          </div>
        </div>
      </div>

      {statisticsData && (
        <CustomComponentAreaCaseBySubmission 
          queryParams={queryParams} StatisticsObjectType={statisticsData.data} title={"Doctors"} 
          isFilterObjUpdated={() => areManFiltersUpdated(queryParams, searchParams, userData, "")}
        />
      )}

      <FooterText />
    </div>
  );
};

export default PracticeStats;
